import React, { useContext } from 'react';
import { LoadingOverlay, openLoader, closeLoader } from 'components/loading-overlay/LoadingOverlay';
import { useDispatch } from 'react-redux';
import { deleteUserAchAccountThunk } from 'common/features/store/duck/account/duck';
import { SERVICE_UNAVAILABLE_MESSAGE } from 'config';
import { hasErrorWithStatus } from 'common/api/utils/hasErrorWithStatus';
import { StatusCode } from 'common/api/config';
import { PaymentOptionsContext } from '../context';
import { useAlert } from 'modules/alerts';

const CannotDeleteAchAccountMessage = () => (
    <p>
        You cannot delete this bank account right now because it's tied to an order that is being
        processed. When processing is complete, you can remove this account.
    </p>
);

export const useAchControls = () => {
    const dispatch = useDispatch<any>();
    const { loader } = useContext(PaymentOptionsContext);
    const alert = useAlert();

    const deleteAch = async () => {
        await openLoader(loader?.current as LoadingOverlay);

        const response = await deleteUserAchAccountThunk(dispatch);
        await closeLoader(loader?.current as LoadingOverlay);

        // if we could not delete the account
        if (response.error) {
            // case where user cannot delete their account because
            // order is being processed
            if (hasErrorWithStatus(response, StatusCode.MethodNotAllowed)) {
                alert({
                    message: <CannotDeleteAchAccountMessage />,
                });
                return;
            }
            alert({ message: SERVICE_UNAVAILABLE_MESSAGE });
        }
    };
    return { deleteAch };
};
